import { useApiQuery } from "hooks/useApiQuery/useApiQuery";
import { CACHE_KEYS } from "commons/constants";
import { renderErrorNotifications } from "helpers/error.helpers";

/**
 * Fetches the activity master list once and returns select-ready options.
 *
 * activityOptions → [{ label: string, value: string }]  (activity_name used for both)
 * activities      → [{ activity_code, activity_name }]  (raw records if needed)
 */
export default function useActivitiesMasterData() {
  const { data, isFetching } = useApiQuery({
    queryKey: CACHE_KEYS.ACTIVITY_MASTER_LIST,
    url: "v1/community-portal/master-data/activity-master/list",
    params: { page_size: 10000, current_page: 1 },
    staleTimeInMinutes: 30,
    onError: (errors) => renderErrorNotifications(errors),
  });

  const activities = data?.data ?? [];

  const activityOptions = activities.map((a) => ({
    label: a.activity_name,
    value: a.activity_name,
  }));

  return { activities, activityOptions, isFetching };
}
